import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IconPerson } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { forwardRef } from 'react';
import { FieldChrome } from '../../../../components/SearchForm/components/FieldChrome/index.js';
import { useTravellersLabelMultiroom } from '../../../../components/SearchForm/components/TravellersFieldMultiroom/hooks/useTravellersLabelMultiroom.js';
import { qaId } from '../../../../utils/index.js';
import { SEARCH_FORM_QA_ID } from '../../../../utils/qaId.js';
export const TravellersFieldMultiroom = forwardRef(function TravellersFieldMultiroom({
  value,
  active,
  layout = 'full',
  ...restProps
}, ref) {
  const {
    t
  } = useTranslation();
  const label = useTravellersLabelMultiroom(value);
  return _jsx(FieldChrome, {
    ...restProps,
    ref: ref,
    layout: layout,
    visuallyFocused: active,
    value: label,
    label: t('searchForm:travellersFieldMultiroom.placeholder'),
    prependIcon: _jsx(IconPerson, {}),
    "data-testid": "travellers-field-multiroom",
    "data-cy": qaId(SEARCH_FORM_QA_ID, 'travellersFieldMultiroom')
  });
});